const isWebView = () => (new URL(window.location.href)).searchParams.get('webView') === '1';

export default isWebView;
